import Cookies from 'js-cookie';

// Navigation only. Every admin request is independently authorized by the backend.
export const hasAdminRole = (token = Cookies.get('token')): boolean => {
  if (!token) return false;
  try {
    const payload = token.replace(/^Bearer\s*/i, '').split('.')[1];
    if (!payload) return false;
    const claims: unknown = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return (
      typeof claims === 'object' &&
      claims !== null &&
      'roles' in claims &&
      Array.isArray(claims.roles) &&
      claims.roles.includes('ROLE_ADMIN')
    );
  } catch {
    return false;
  }
};
